import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Sparkles } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/login");
      return;
    }

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        const u = res.data.user;
        setUser(u);
        window.history.replaceState(null, "", window.location.pathname);
        if (!u.role) navigate("/onboarding", { replace: true });
        else if (u.role === "manager") navigate("/admin", { replace: true });
        else if (u.role === "ecommerce_admin") navigate("/ecommerce", { replace: true });
        else if (u.role === "affiliator") navigate("/affiliator", { replace: true });
        else navigate("/creator", { replace: true });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-showty-cream" data-testid="auth-callback">
      <Sparkles className="w-8 h-8 text-showty-red animate-pulse" />
      <p className="mt-4 font-display text-2xl text-showty-navy">Menyiapkan ruang glam kamu…</p>
    </div>
  );
}
